import { useEffect, useState } from 'react';
import { Icons } from '../Icons.jsx';
import { speak } from '../../utils/speech.js';
import { BALL } from '../../theme.js';

const T = BALL;

export default function MultipleChoice({ exercise, lang, onResult, locked }) {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setSelected(null);
  }, [exercise]);

  const isToHR = exercise.direction === 'toHR';
  const eyebrowColor = isToHR ? T.primary : T.gold;
  const eyebrow = isToHR
    ? (lang === 'en' ? 'CHOOSE THE TRANSLATION' : 'VÄLJ ÖVERSÄTTNINGEN')
    : (lang === 'en' ? 'WHAT DOES THIS MEAN?' : 'VAD BETYDER DETTA?');
  const titleText = isToHR
    ? (lang === 'en' ? `How do you say "${exercise.prompt}"?` : `Vad heter "${exercise.prompt}"?`)
    : (lang === 'en' ? 'Tap the correct meaning' : 'Tryck på rätt betydelse');

  function pick(opt) {
    if (locked) return;
    setSelected(opt);
    onResult({ correct: opt === exercise.correct, given: opt, expected: exercise.correct });
  }

  return (
    <div style={{ padding: '4px 22px 0', display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <div style={{
          fontSize: 11, fontWeight: 800, color: eyebrowColor, letterSpacing: '0.12em',
        }}>{eyebrow}</div>
        <h2 style={{
          fontSize: 24, fontWeight: 900, color: T.ink, margin: '6px 0 0', lineHeight: 1.15,
        }}>{titleText}</h2>
      </div>

      {!isToHR && (
        <button
          type="button"
          onClick={() => speak(exercise.speakText)}
          style={{
            appearance: 'none', cursor: 'pointer',
            background: T.bgAlt, border: `2px solid ${T.hairline}`,
            borderRadius: 16, padding: '14px 16px',
            boxShadow: `0 3px 0 ${T.hairline}`,
            display: 'flex', alignItems: 'center', gap: 14,
            textAlign: 'left', fontFamily: 'inherit', width: '100%',
          }}
        >
          <div style={{
            width: 44, height: 44, borderRadius: '50%',
            background: T.blue, color: '#fff', flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: `0 3px 0 ${T.blueDeep}`,
          }}>
            {Icons.speaker('#fff')}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: T.primary }}>{exercise.prompt}</div>
            <div style={{
              fontSize: 11, fontWeight: 800, color: T.primary,
              letterSpacing: '0.06em', marginTop: 4, opacity: 0.85,
            }}>
              ▶ {lang === 'en' ? 'TAP TO HEAR' : 'TRYCK FÖR ATT HÖRA'}
            </div>
          </div>
        </button>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {exercise.options.map((opt, i) => {
          const isSel = selected === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => pick(opt)}
              disabled={locked}
              style={{
                appearance: 'none', cursor: locked ? 'not-allowed' : 'pointer',
                background: T.bgAlt,
                border: `2px solid ${isSel ? T.blue : T.hairline}`,
                boxShadow: `0 3px 0 ${isSel ? T.blueDeep : T.hairline}`,
                borderRadius: 14, padding: '14px 12px',
                fontWeight: 800, fontSize: 16,
                color: isSel ? T.blue : T.ink,
                textAlign: 'left',
                display: 'flex', alignItems: 'center', gap: 10,
                minHeight: 60,
                fontFamily: 'inherit',
              }}
            >
              <div style={{
                width: 22, height: 22, borderRadius: 6,
                background: isSel ? T.blue : T.hairline,
                color: '#fff', fontWeight: 900, fontSize: 12,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>{i + 1}</div>
              <span>{opt}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
